import React, { useState } from 'react';
import Select, { SelectProps } from '@mui/material/Select';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './NereusSelect.scss';

const NereusSelect: React.FC<SelectProps> = (props: SelectProps) => {
    const [open, setOpen] = useState(false);

    return (
        <Select
            {...props}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            IconComponent={() => (open ? <KeyboardArrowUpIcon className="NereusSelect__icon" /> : <KeyboardArrowDownIcon  className="NereusSelect__icon" />)}
        />
    );
};

export default NereusSelect;